const adminBackofficeDictIT = {
  adverts: "Annunci",
  users: "Utenti",
  orders: "Ordini",
  paidSubscriptions: "Abbonamenti a pagamento",
  paymentMethod: "Metodo di pagamento",
  initialSub: "Registrazione iniziale",
  annualRenewal: "Rinnovo annuale",
  test: "test",
  adminDashboard: "Pannello di amministrazione",
  withdrawRequests: "Richieste di prelievo",
  excWithdrawRequests: "Prelievi Extracoin",
  markExcWithdrawCompleted: "Segna come completato",
  processThisExcWithdrawRequest: "Segnare questa richiesta come completata?",
  excWithdrawProcessedSuccessfully: "Richiesta di prelievo Extracoin elaborata con successo!",
  searchByUsernameEmailAddress: "Cerca per username, email o indirizzo",
  requestDate: "Data richiesta",
  processDate: "Data di elaborazione",
  processing: "In lavorazione",
  amountToDeposit: "Ammontare da depositare",
  amountRequested: "Importo richiesto",
  processRequest: "Processi la richiesta",
  process: "Processi",
  processedBy: "Elaborato da",
  withdrawProcessedSuccessfully: "Richiesta di prelievo elaborata con successo!",
  blockOrUnblockUser: "Blocca/Sblocca utente",
  block: "Blocca",
  unblock: "Sblocca",
  user: "Utente",
  processThisRequest: "Elaborare questa richiesta?",
  userBlockedSuccessfully: "Utente bloccato con successo.",
  userUnblockedSuccessfully: "Utente sbloccato con successo!",
  areYouSureBlockUser: "Sei sicuro di voler bloccare questo utente?",
  areYouSureUnblockUser: "Sei sicuro di voler sbloccare questo utente?",
  blocked: "Bloccato",
  yes: "Sì",
  no: "No",
  category: "Categoria",
  searchCategory: "Cerca Categoria",
  categoriesRegistered: "Categorie registrate",
  titleCategory: "Título",
  image: "Immagine",
  descriptionPT: "Descrizione portoghese",
  descriptionIT: "Descrizione italiana",
  descriptionES: "Descrizione spagnola",
  descriptionEN: "Descrizione inglese",
  registerNewCategory: "registra nuova categoria",
  addNewCategory: "Aggiungi nuova categoria",
  newCategory: "Nuovo",
  categoryInfo: "Informazioni sulla categoria",
  categoryFields: "Compila i campi con le informazioni sulla categoria.",
  categoryImage: "Immagine categoria",
  dragImg: "Trascina qui la tua immagine",
  registerCategory: "Registrati",
  descriptionBrand: "Descrizione del marchio",
  brandsRegistered: "Marchi",
  brands: "Marchi",
  addNewBrand: "Aggiungi nuovo marchio",
  brandInfo: "Informazioni sul marchio",
  brandFields: "Compila il campo con le informazioni sul marchio.",
  registerBrand: "Register",
  newBrand: "Nuovo",
  typesCategoriesRegistered: "Tipi di categorie registrati",
  descriptionType: "Descrizione",
  descriptionTypeEN: "Descrizione inglese",
  descriptionTypeES: "Descrizione spagnola",
  descriptionTypeIT: "Descrizione italiana",
  descriptionTypePT: "Descrizione portoghese",
  types: "Tipi",
  addNewType: "Aggiungi nuovi tipi",
  typeInfo: "Informazioni sul tipo",
  typeFields: "Compila i campi con le informazioni sul tipo.",
  newType: "Nuovo",
  registerType: "Register",
  subcategory: "Sottocategorie",
  newsubcategory: "Nuovo",
  subcategoriesRegistered: "Sottocategorie registrate",
  descriptionSubcategoryEN: "Descrizione inglese",
  descriptionSubcategoryIT: "Descrizione italiana",
  descriptionSubcategoryPT: "Descrizione portoghese",
  descriptionSubcategoryES: "Descrizione in spagnolo",
  service: "servizio",
  addNewSubcategory: "Aggiungi nuova sottocategoria",
  subcategoryInfo: "Informazioni sulla sottocategoria",
  subcategoryFields: "Compila i campi con le informazioni sulla sottocategoria.",
  subcategoryImage: "Immagine sottocategoria",
  registerSubcategory: "Registrati",
  chooseSubcategory: "Scegli almeno una sottocategoria",
  address: "Indirizzo",
  userType: "tipologia di utente",
  chooseUser: "scegli un utente",
  chooseAddress: "scegli un indirizzo",
  UserAddressOnSendCloud: "L'indirizzo dell'utente era registrato in sendcloud?",
  searchUser: "Cerca utente.",
  userInfo: "Informazioni utente",
  adminBackofficeName: "Nome",
  hasNoAttributes: "Non ha",
  adminBackofficeUserType: "Tipologia di utente",
  adminBackofficeCountry: "Paese",
  adminBackofficeAddress: "Indirizzo",
  adminBackofficeCity: "Città",
  adminBackofficeState: "Stato",
  adminBackofficeDistrict: "Distretto",
  adminBackofficePostalCode: "Codice postale",
  adminBackofficeNumber: "Numero",
  adminBackofficeComplement: "Complemento",
  adminBackofficeDateCreation: "Data di creazione",
  adminBackofficePhoneNumber: "Telefono",
  adminBackofficeOriginRegister: "Origine registrazione",
  searchByEmail: "ricerca tramite e-mail",
  searchByFirstname: "ricerca per nome",
  searchByPhonenumber: "Cerca per numero di telefono",
  searchByReferralName: "Cerca per referenza",
  searchByBrand: "cerca per marca",
  usersOfSystem: "Utenti del sistema",
  productsNotPublished: "Prodotti non pubblicati",
  archivedProducts: "Prodotti archiviati",
  productsPublished: "Prodotti pubblicati",
  salesRevenue: "Volume di Transazioni",
  feeRevenue: "Ricavi delle commissioni",
  registeredStores: "Negozi registrati",
  completedOrders: "Ordini completati",
  revenueFromUserRegistration: "Ricavi dalla registrazione degli utenti",
  productsOfSystem: "Prodotti del sistema",
  filters: "Filtri",
  search: "Cerca",
  searchByNameSurnameUserAccountBank: "Cerca per nome, cognome, utente, conto bancario",
  ordersPlacedWithBangood: "Ordini effettuati con Bangood",
  actions: "Azioni",
  processOrderSuccessfully: "Ordine elaborato con successo!",
  metaAdsConfig: "Impostazione degli annunci Meta",
  integrationConfig: "Impostazioni di integrazione",
  editIntegrationConfig: "Modifica della configurazione",
  accessToken: "Token di accesso",
  pixelNumberId: "Numero ID del Pixel",
  savePixelConfig: "Salvare la configurazione",
  integrations: "Integrazioni",
  pixelConfigSaved: "Configurazione salvata!",
  pixelConfigSavedDetail: "Le impostazioni dell'annuncio Meta sono state salvate con successo.",
  pixelConfigError: "Errore imprevisto",
  pixelConfigErrorDetail:
    "Si è verificato un errore durante il tentativo di salvare le impostazioni.",
  fillInAllFields: "Compila tutti i campi!",
  googleTagManagerConfiguration: "Configura Google Tag Manager",
  gtmCodeSaved: "Codice GTM salvato",
  gtmCode: "Codice GTM",
  gtmEdit: "Modifica codice GTM",
  gtmRegister: "Registra il codice GTM",
  confirmed: "Pagamento confermato",
  paymentConfirmed: "Avete confermato la ricezione del pagamento tramite bonifico bancario.",
  pendingOrders: "Ordini in sospeso",
  transferConfirm: "Confermare il trasferimento",
  buyer: "Acquirente",
  totalAmount: "Valore totale",
  date: "Data",
  noPendingOrders: "Nessun ordine di bonifico in sospeso.",
  youHavePendingOrders: "Avete vendite in sospeso",
  youHavePendingUsers: "Hai utenti in sospeso",
  seeYourPendingOrders: "Controllare le vendite di bonifici bancari in corso.",
  seeYourPendingUsersBankTransfer: "Controlla gli utenti con bonifici bancari in sospeso.",
  pendings: "Vendite in sospeso",
  usersPendings: "Utenti in sospeso",
  bankTransfers: "Bonifici bancari",
  searchForPlan: "Cerca per piano",
  authorize: "Autorizzare",
  confirmTransfer: "Confermi il trasferimento?",
  receipt: "Prova",
  pendingIssues: "Problemi in sospeso",
  quantityOfWithdrawsCompleted: "Quantità di prelievi completati",
  totalAmountWithdrawsCompleted: "Importo totale dei prelievi completati",
  totalOfUsersPublishedAds: "Totale degli utenti che hanno pubblicato annunci",
  totalofCommissionsPaid: "Totale delle commissioni pagate",
  bestOffers: "MIGLIORI OFFERTE",
  youHaveUnprocessedOrders: "Hai ordini Bangood non elaborati",
  pendingBangoodOrders: "Visualizza i tuoi ordini Bangood non elaborati.",
  bannersOfShop: "Banner del negozio",
  dragJustOneImage: "Trascina solo un'immagine",
  language: "Lingua",
  english: "Inglese",
  portuguese: "Portoghese",
  italian: "Italiano",
  spanish: "Spagnolo",
  dontHaveImage: "Non hai un'immagine?",
  principalBanner: "Banner principale",
  file: "File",
  showBanner: "Mostra banner",
  noImageSelected: "nessuna immagine selezionata",
  keepImageInRequiredAspectRatio: "Mantenere l'immagine nel rapporto di aspetto richiesto",
  doYouWantToRepeatThisImage: "Vuoi ripetere questa immagine per un altro banner?",
  documents: "Documenti",
  document: "Documento",
  seeDoc: "Vedi documento",
  downloadDoc: "Scarica il documento",
  urlToRedirect: "URL per reindirizzare l'utente quando clicca sul banner",
  addNewBanner: "Aggiungi nuovo banner",
  removeBanner: "Rimuovi banner",
  settingsSaved: "Impostazioni salvate",
  generalSettings: "Impostazioni generali",
  sliderChangeTime: "Tempo di cambio cursore",
  seconds: "Secondi",
  imageDesktopEnglish: "Immagine Desktop inglese",
  imageDesktopItalian: "Immagine Desktop italiano",
  imageDesktopPortuguese: "Immagine Desktop portoghese",
  imageDesktopSpanish: "Immagine Desktop spagnola",
  imageMobileEnglish: "Immagine Mobile inglese",
  imageMobileItalian: "Immagine Mobile italiana",
  imageMobilePortuguese: "Immagine Mobile portoghese",
  imageMobileSpanish: "Immagine Mobile spagnola",
  youHavePendingWithdraws: "Hai prelievi in sospeso",
  seeYourPendingWithdraws: "Visualizza i tuoi prelievi in sospeso.",
  youHavePendingPhysicalStores: "Hai negozi fisici in attesa di verifica",
  seeYourPendingPhysicalStores: "Rivedi i negozi in attesa di approvazione.",
  withdrawPendings: "Prelievi in sospeso",
  subnets: "Sub-reti",
  ownerName: "Nome del proprietario",
  pleaseEnterName: "Per favore, inserisci un nome",
  pleaseEnterDescription: "Per favore, inserisci una descrizione",
  pleaseSelectManager: "Per favore, seleziona un manager",
  whitelabelSubnetCreatedSuccessfully: "Subnet Whitelabel creata con successo",
  errorCreatingWhitelabelSubnet: "Errore durante la creazione della subnet Whitelabel",
  personalizeSubnetTheme: "Personalizza il tema della subnet",
  personalizeTeam: "Personalizza tema",
  reports: "Rapporti contabili",
  paidOrdersReport: "Rapporto sugli ordini pagati",
  completedWithdrawalsReport: "Rapporto sui prelievi completati",
  paidSubscriptionsReport: "Rapporto sugli abbonamenti a pagamento",
  downloadPdf: "Scarica PDF",
  noData: "Nessun dato disponibile",
  pdfDownloadedSuccessfully: "PDF scaricato con successo",
  errorDownloadingPdf: "Errore durante il download del PDF",
  errorFetchingData: "Errore nel recupero dei dati",
  success: "Successo",
  taxId: "P.IVA / Cod. Fiscale",
  planType: "Tipo Piano",
  startDate: "Data di inizio",
  endDate: "Data di fine",
  exportData: "Esporta dati",
  paidOrdersHeaderNumber: "N°",
  paidOrdersHeaderBuyer: "Acquirente",
  paidOrdersHeaderSeller: "Venditore",
  paidOrdersHeaderDate: "Data",
  paidOrdersHeaderOrderAmount: "Imp. Ordine",
  paidOrdersHeaderPaidAmount: "Imp. Pagato",
  paidOrdersHeaderCommission: "Commissione",
  paidOrdersHeaderPayPal: "PayPal",
  paidOrdersHeaderWallet: "Wallet",
  paidOrdersHeaderExtraCredit: "ExtraCredit",
  paidOrdersHeaderBankTransfer: "Bonifico",
  paidOrdersHeaderStatus: "Stato",
  paidOrdersHeaderInvoiceBuyer: "Fattura Acquirente",
  paidOrdersHeaderInvoiceSeller: "Fattura Venditore",
  paidOrdersHeaderPlatformFeeBuyer: "Commissione Piattaforma Acquirente (5%)",
  paidOrdersHeaderPlatformFeeSeller: "Commissione Piattaforma Venditore (5%)",
  paidOrdersHeaderPaidToSeller: "Pagato al Venditore",
  paidOrdersStatusOnHold: "In attesa",
  completedWithdrawalsHeaderId: "ID",
  completedWithdrawalsHeaderDestination: "Destinazione",
  completedWithdrawalsHeaderProcessedBy: "Processato da",
  completedWithdrawalsHeaderRequestDate: "Data richiesta",
  completedWithdrawalsHeaderProcessDate: "Data processo",
  completedWithdrawalsHeaderAmountRequested: "Importo richiesto",
  completedWithdrawalsHeaderAmountToDeposit: "Importo da accreditare",
  completedWithdrawalsHeaderFee: "Commissione",
  completedWithdrawalsColDestinationType: "Tipo Dest.",
  completedWithdrawalsColPayment: "Pagamento",
  completedWithdrawalsColRequestedValue: "Val. Rich.",
  completedWithdrawalsColNetValue: "Val. Netto",
  searchBySurname: "Cerca per cognome",
  searchByDocument: "Cerca per documento",
  searchByAddress: "Cerca per indirizzo",
  searchByPaymentMethod: "Cerca per metodo di pagamento",
  orderNumber: "Numero ordine",
  logoutAccount: "Esci dall'account",
  logoOrFavicon: "Puoi inviare solo il logo, solo il favicon o entrambi",
  footerFieldsInfo: "I campi sottostanti appariranno nel footer della dashboard del whitelabel.",
  approveStore: "Approva negozio",
  rejectStore: "Rifiuta negozio",
  confirmApproveStore: "Sei sicuro di voler approvare questo negozio?",
  enterRejectionReason: "Inserisci il motivo del rifiuto",
  storeApprovedSuccessfully: "Negozio approvato con successo!",
  storeRejectedSuccessfully: "Negozio rifiutato con successo!",
  physicalStores: "Negozi Fisici",
  physicalStoresRegistered: "Negozi Fisici Approvati",
  physicalStoresApproved: "Negozi Approvati",
  physicalStoresPending: "Verifiche in Sospeso",
  searchByStoreName: "Cerca per nome del negozio",
  physicalStoreName: "Nome del negozio",
  storeOwner: "Proprietario",
  viewDetails: "Visualizza dettagli",
  storeDetails: "Dettagli del negozio",
  conventionPdf: "PDF della Convenzione",
  legalRepresentative: "Rappresentante legale",
  piva: "PIVA",
  signatureIp: "IP della firma",
  signedAt: "Firmato il",
  openPhoto: "Apri foto",
  openConvention: "Apri PDF della convenzione",
  establishmentPhoto: "Foto dello stabilimento",
  verificationStatus: "Stato",
  submittedAt: "Inviato il",
  statusPending: "In attesa",
  statusApproved: "Approvata",
  statusRejected: "Rifiutata",
  storeCompanyName: "Ragione sociale",
  commercialName: "Nome commerciale",
  merchantCategory: "Categoria dell'esercizio",
  storePhone: "Telefono del negozio",
  invoiceStatus: "Fatturazione",
  invoiceStatusSent: "Fattura emessa",
  invoiceStatusError: "Errore nell'emissione della fattura",
  invoiceStatusPending: "Fattura in attesa",
  invoiceStatusNotApplicable: "Non applicabile",
  automaticInvoicing: "Fatturazione Automatica",
  automaticInvoicingDescription: "Abilita o disabilita l'emissione automatica della fattura elettronica per gli abbonamenti pagati e per gli ordini.",
  invoicingEnabledSuccessfully: "Fatturazione automatica abilitata con successo",
  invoicingDisabledSuccessfully: "Fatturazione automatica disabilitata con successo",
  errorTogglingInvoicing: "Errore durante la modifica della fatturazione automatica",
  errorFetchingInvoicingStatus: "Errore durante il recupero dello stato della fatturazione automatica",
};

export default adminBackofficeDictIT;
